var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLink = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline / Text Formatting / Link"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6069 3.23662C14.8021 2.03671 16.5505 2.01151 17.5184 2.98315C18.4881 3.95663 18.462 5.716 17.2659 6.91672L15.2461 8.94443C15.0025 9.18898 15.0032 9.5847 15.2478 9.82831C15.4923 10.0719 15.8881 10.0711 16.1317 9.82659L18.1515 7.79889C19.7443 6.19996 19.9442 3.64719 18.404 2.10098C16.862 0.552939 14.3148 0.754699 12.7213 2.35445L8.68157 6.40983C7.08882 8.00876 6.88886 10.5616 8.42908 12.1078C8.67268 12.3523 9.06841 12.3531 9.31296 12.1095C9.55751 11.8659 9.55828 11.4701 9.31467 11.2256C8.34496 10.2521 8.37108 8.49272 9.56716 7.292L13.6069 3.23662Z",
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5707 7.89226C12.3271 7.64771 11.9313 7.64694 11.6868 7.89055C11.4422 8.13415 11.4415 8.52988 11.6851 8.77443C12.6548 9.74791 12.6287 11.5073 11.4326 12.708L7.3929 16.7634C6.19763 17.9633 4.44923 17.9885 3.48134 17.0169C2.51163 16.0434 2.53774 14.284 3.73383 13.0833L5.7537 11.0556C5.9973 10.811 5.99654 10.4153 5.75199 10.1717C5.50744 9.92807 5.11171 9.92883 4.8681 10.1734L2.84824 12.2011C1.25549 13.8 1.05552 16.3528 2.59575 17.899C4.13781 19.4471 6.68494 19.2453 8.2785 17.6456L12.3182 13.5902C13.9109 11.9912 14.1109 9.43847 12.5707 7.89226Z",
    fill: "#3B82F6"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Link.49ca03c390bea0b68543516b541df1b6.svg";